import { render, staticRenderFns } from "./RemoveContract.vue?vue&type=template&id=ba58ffaa&scoped=true&"
import script from "./RemoveContract.vue?vue&type=script&lang=js&"
export * from "./RemoveContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba58ffaa",
  null
  
)

export default component.exports